import Redux from 'redux';
import * as Bixby from '$/core';
import {
  TRANSACTION_COMPS_LOADING,
  TRANSACTION_COMPS_SUCCESS,
  TRANSACTION_COMPS_FAILURE,
  TransactionCompsState,
  TransactionCompsActionTypes,
} from './types';
import { LOGIN_CLEAR_PRELOADED_DATA } from '$/store/login/types';

const initialState: TransactionCompsState = {
  isLoading: false,
  transactionComps: undefined,
  error: undefined,
};

const transactionCompsReducer: Redux.Reducer<TransactionCompsState> = (
  state = initialState,
  action: TransactionCompsActionTypes
): TransactionCompsState => {
  switch (action.type) {
    case LOGIN_CLEAR_PRELOADED_DATA:
      return initialState;
    case TRANSACTION_COMPS_LOADING:
      return {
        ...state,
        isLoading: true,
        error: undefined,
      };
    case TRANSACTION_COMPS_SUCCESS:
      return {
        ...state,
        isLoading: false,
        transactionComps: action.payload as Bixby.Models.CompanyTransactionComp[],
        error: undefined,
      };
    case TRANSACTION_COMPS_FAILURE:
      return {
        ...state,
        isLoading: false,
        error: action.payload as Bixby.Models.BixbyError,
        transactionComps: undefined,
      };
    default:
      return state;
  }
};

export default transactionCompsReducer;
